import { render, staticRenderFns } from "./createPedidoCompra.vue?vue&type=template&id=23dcaeed&scoped=true&"
import script from "./createPedidoCompra.vue?vue&type=script&lang=js&"
export * from "./createPedidoCompra.vue?vue&type=script&lang=js&"
import style0 from "./createPedidoCompra.vue?vue&type=style&index=0&id=23dcaeed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dcaeed",
  null
  
)

export default component.exports